import React, { useState, useEffect, useRef } from "react";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";

const StepperInput = ({
  initialValue = 15,
  step = 5,
  min = 10,
  max = 100,
  onChange,
  className = "",
  buttonClassName = "",
  inputClassName = "",
  displayClassName = "",
}) => {
  const [value, setValue] = useState(initialValue);
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    if (isEditing) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const handleChange = (e) => {
    const newValue = parseInt(e.target.value, 10);
    if (!isNaN(newValue)) {
      const updatedValue = Math.min(Math.max(newValue, min), max);
      setValue(updatedValue);
      if (onChange) {
        onChange(updatedValue);
      }
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const increment = (e) => {
    e.preventDefault();
    const newValue = Math.min(value + step, max);
    setValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const decrement = (e) => {
    e.preventDefault();
    const newValue = Math.max(value - step, min);
    setValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <div
      className={`flex items-center justify-center  gap-2  w-full sm:w-48 bg-white dark:bg-gray-800 p-2 rounded-lg border dark:border-gray-700 shadow-sm ${className}`}
    >
      <button
        onClick={decrement}
        className={`w-8 h-8 rounded-full flex items-center justify-center focus:outline-none bg-gray-200 dark:bg-gray-700 ${buttonClassName} ${
          value <= min ? "opacity-30" : ""
        }`}
        disabled={value <= min}
      >
        <MinusIcon className="w-4 h-4" />
      </button>
      {isEditing ? (
        <input
          ref={inputRef}
          type="number"
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`w-20 lg:w-32 text-white text-md font-bold text-center bg-primary border dark:border-gray-700 rounded ${inputClassName}`}
          min={min}
          max={max}
        />
      ) : (
        <span
          onClick={() => setIsEditing(true)}
          className={`text-md text-white font-bold w-10 lg:w-16 text-center bg-primary py-1 rounded-lg cursor-pointer ${displayClassName} `}
        >
          {value}
        </span>
      )}
      <button
        onClick={increment}
        className={`w-8 h-8 rounded-full flex items-center justify-center focus:outline-none bg-gray-200 dark:bg-gray-700 ${buttonClassName} ${
          value >= max ? "opacity-30" : ""
        } `}
        disabled={value >= max}
      >
        <PlusIcon className="w-4 h-4" />
      </button>
    </div>
  );
};

export default StepperInput;
